import React, { useState, useEffect } from "react"
import { makeStyles } from "@material-ui/core/styles"
import Typography from "@material-ui/core/Typography"
import { Button, GridDialog, TextField } from ".."
import { FormattedMessage, injectIntl } from "react-intl"

const useStyles = makeStyles(theme => ({
  body: {
    alignItems: "center",
    display: "flex",
    flexDirection: "column",
    padding: theme.spacing(8, 0),
  },
  content: {
    width: "100%",
    maxWidth: theme.spacing(50),
  },
  submitButton: {
    marginTop: theme.spacing(1),
    width: "100%",
  },
  title: {
    color: theme.palette.green.main,
    textAlign: "center",
  },
  failureTitle: {
    color: theme.palette.red.main,
    textAlign: "center",
  },
  bodyText: {
    marginBottom: theme.spacing(4),
  },
  successText: {
    textAlign: "center",
    marginBottom: theme.spacing(4),
  },
  leafLeft: {
    position: "absolute",
    left: 0,
    top: "10%",
    width: 80,
    height: 77,
    [theme.breakpoints.down("sm")]: {
      display: "none",
    },
  },
  leafRight: {
    position: "absolute",
    right: 0,
    bottom: "10%",
    width: 80,
    height: 77,
    [theme.breakpoints.down("sm")]: {
      display: "none",
    },
  },
}))

export default injectIntl(props => {
  let initialState = process.env.NewsletterDialogInitialShow === "true" || false;
  const [open, setOpen] = useState(initialState)
  const [email, setEmail] = useState("")
  const [confirmation, setConfirmation] = useState(false)
  const [failure, setFailure] = useState(false)

  const classes = useStyles()
  useEffect(() => {
    setTimeout(() => {
      if (initialState) {
        setOpen(true)
      }
    }, 6000)
  }, [])

  const handleClose = () => {
    setOpen(false)
    if (typeof window !== 'undefined') window.localStorage.setItem("didTheUserCloseTheModal",true)
  }

  const handleChange = value => {
    setEmail(value)
  }

  const handleSubmit = () => {
    if (typeof window !== 'undefined') window.localStorage.setItem("didTheUserCloseTheModal",true)
    if (emailValidation(email) === "") {
      const data = {
	         "case": 1,
	         "email": email,
      }
      fetch('https://55mdpi5wl2.execute-api.sa-east-1.amazonaws.com/prod/moltin_cart_calls', {
        method: 'post',
        body: JSON.stringify(data)
      }).then(entry => {
          setConfirmation(true)
          setTimeout(() => {
            setOpen(false)
            setConfirmation(false)
          }, 6000)
        })
        .catch(error => {
          setFailure(true)
        })
      }
  }

  const { intl } = props
  const i18nmessages = intl.messages

  const emailValidation = value => {
    // eslint-disable-next-line
    const regex = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
    return regex.test(value) ? "" : "Please enter a valid email address."
  }

  return (
    <GridDialog
      showCloseButton
      fullScreen={"sm"}
      xs={8}
      onClose={handleClose}
      open={open}
    >
      <div className={classes.body}>
        <img src={props.bgImgLeft} className={classes.leafLeft} alt={""} />
        <img src={props.bgImgRight} className={classes.leafRight} alt={""} />
        <div className={classes.content}>
          {confirmation ? (
            <Typography
              id={props.titleId}
              variant={"h4"}
              classes={{ root: classes.title }}
            >
              <FormattedMessage id="thanksForSubscribing" />
            </Typography>
          ) : failure ? (
            <Typography
              id={props.titleId}
              variant={"h4"}
              classes={{ root: classes.failureTitle }}
            >
              <FormattedMessage id="somethingWentWrong" />
            </Typography>
          ) : (
            <Typography
              id={props.titleId}
              variant={"h4"}
              classes={{ root: classes.title }}
            >
              <FormattedMessage id="welcomeTo" /> Pura Earth
            </Typography>
          )}
          {!confirmation && !failure ? (
            <TextField
              label={i18nmessages.emailAddress}
              type={"email"}
              onChange={handleChange}
              validation={emailValidation}
            />
          ) : null}
          {!confirmation && !failure ? (
            <Button
              data-cy="submit-newsletter"
              className={classes.submitButton}
              color={"green"}
              onClick={handleSubmit}
            >
              <FormattedMessage id="submit" />
            </Button>
          ) : null}
        </div>
      </div>
    </GridDialog>
  )
})
